import { useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { logClientError } from '../api/users-api';
import GpanelLogoWhite from '../assets/gpanel-logo.png';
import { TierError } from '../utils/custom-errors';
import { PermissionError } from '../utils/custom-errors';
import posthog from 'posthog-js';
import axios from 'axios';
import { auth } from '../shared/firebase/firebase-config';

import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function RouterErrorBoundary() {
  const error = useRouteError();
  const isSessionTimeout =
    axios.isAxiosError(error) && error.response?.status === 401;

  useEffect(() => {
    if (isSessionTimeout) {
      const currentPath = window.location.pathname;
      const redirectUrl =
        currentPath === '/'
          ? '/login?session-timeout=true'
          : `/login?session-timeout=true&from=${encodeURIComponent(
              currentPath
            )}`;

      async function logoutAndRedirect() {
        try {
          await auth.signOut();
        } catch {
          // ignore sign out errors, continue with redirect
        } finally {
          window.location.replace(redirectUrl);
        }
      }

      logoutAndRedirect();
      return;
    }

    if (error instanceof PermissionError || error instanceof TierError) {
      return;
    }

    if (error instanceof Error) {
      logClientError(error, 'Router Error Boundary', window.location.href);

      if (import.meta.env.MODE !== 'development') {
        posthog.captureException(error, {
          module: 'Router Error Boundary',
          section: 'Router Error Boundary',
          location: window.location.href,
        });
      }
    }
  }, [error, isSessionTimeout]);

  if (isSessionTimeout) {
    return null;
  }

  return (
    <Stack
      sx={{
        height: '100vh',
        width: '100vw',
        bgcolor: 'grey.900',
      }}
      justifyContent="center"
      alignItems="center"
      gap={2}
    >
      <img src={GpanelLogoWhite} alt="gPanel Logo" width={300} />
      <Typography color="white" variant="h6">
        We had an issue logging you in. Please try refreshing the page, and
        email support at{' '}
        <Link href="mailto:support@promevo.com">support@promevo.com</Link> if
        the issue persists.
      </Typography>
    </Stack>
  );
}
